import React from "react";
import BreadcrumbTwo from "../components/BreadcrumbTwo";
import DeveloperMe from "../components/DeveloperMe";

const Developer = () => {
  return (
    <>
        <BreadcrumbTwo title="Developer" />
        <DeveloperMe />
    </>
  )
}

export default Developer